import { Table, Button } from "react-bootstrap";

/**
 * StudentSelectorSkeleton Component
 * A reusable skeleton loader for the student selector tables
 * Shows a loading state while student data is being fetched
 *
 * @param {Object} props
 * @param {number} [props.rows=5] - Number of skeleton rows to display
 * @param {string} [props.type="select"] - Type of table ("select" or "selected")
 */
const StudentSelectorSkeleton = ({ rows = 5, type = "select" }) => {
  return (
    <div className="custom-table-container">
      <div className="custom-table-wrapper select-student-table-scroll">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              <th>
                <div
                  className="skeleton-box"
                  style={{
                    height: "20px",
                    width: "80%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                ></div>
              </th>
              <th>
                <div
                  className="skeleton-box"
                  style={{
                    height: "20px",
                    width: "80%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                ></div>
              </th>
              <th>
                <div
                  className="skeleton-box"
                  style={{
                    height: "20px",
                    width: type === "select" ? "60%" : "40%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                ></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                <td>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: "90%",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIndex * 0.1}s`,
                    }}
                  ></div>
                </td>
                <td>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: "85%",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIndex * 0.1}s`,
                    }}
                  ></div>
                </td>
                <td>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: type === "select" ? "24px" : "50%",
                      backgroundColor: "#e0e0e0",
                      borderRadius: type === "select" ? "3px" : "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIndex * 0.1}s`,
                    }}
                  ></div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Add Students Button Skeleton for "select" type */}
      {type === "select" && (
        <div className="add-students-button-wrapper">
          <Button
            variant="dark"
            disabled
            className="add-students-button"
            style={{
              opacity: 0.6,
              cursor: "not-allowed",
            }}
          >
            <div
              className="skeleton-box"
              style={{
                height: "16px",
                width: "120px",
                backgroundColor: "#ffffff40",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
                display: "inline-block",
              }}
            ></div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default StudentSelectorSkeleton;
